import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useToast } from "../../../../context/ToastContext";
import api from "../../../utils/api";
import { openLoginModal } from "../../../../redux/authSlice";

const GameCard = ({ game }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.user);
  const { showToast } = useToast();

  // Helper function to get image URL
  const getImageUrl = (img) => {
    if (!img) return null;
    if (typeof img === "string") return img;
    return img;
  };

  const handleGameClick = async () => {
    // if (!user) {
    //     dispatch(openLoginModal());
    //     return;
    // }

    try {
      const res = await api.get(`/games/id/${game._id}`);
      if (res.data.success && res.data.data) {
        const gameData = res.data.data;
        if (gameData && gameData.slug) {
          navigate(`/games/${gameData.slug}`, { state: { autoScroll: true } });
        } else {
          console.error("Game missing slug", gameData);
          showToast("Unable to launch game: Missing information", "danger");
        }
      }
    } catch (error) {
      console.error("Error fetching game details:", error);
      showToast("Failed to fetch game details. Please try again.", "danger");
    }
  };

  return (
    <div
      className="casino-game-card"
      onClick={handleGameClick}
      style={{ cursor: "pointer" }}
    >
      {/* Default Placeholder Text (Visible if image missing/fails) */}
      <div className="casino-placeholder-text">ambeworlds</div>

      {/* Game Background Image */}
      {getImageUrl(game.thumbnail) && (
        <img
          className="casino-game-background"
          src={getImageUrl(game.thumbnail)}
          alt={game.name}
          onError={(e) => {
            e.target.style.display = "none";
          }}
        />
      )}

      <div
        className="casino-game-gradient"
        style={{
          background:
            "linear-gradient(135deg, rgba(0,0,0,0.4), rgba(0,0,0,0.8))",
        }}
      />

      {/* Game Title */}
      <div className="casino-game-title">{game.name}</div>
    </div>
  );
};

export default GameCard;
